import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface BoundedNameDTO {
  name: string;
}

export class BoundedName {
  readonly isBoundedNameBoundedName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "minSize": 1,
      "maxSize": 255,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    BoundedName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: BoundedNameDTO): BoundedName {
    const name = getString(dto, "name", InvalidBoundedNameNameError);
    return new BoundedName(
      name
    );
  }

  toDTO(): BoundedNameDTO {
    const dto: BoundedNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length < 1) {
      throw new InvalidBoundedNameNameMinSizeError(
        1,
        `Attribute name is too short. Size is ${name.length}. Min size is 1.`
      );
    }
    if(name.length > 255) {
      throw new InvalidBoundedNameNameMaxSizeError(
        255,
        `Attribute name is too long. Size is ${name.length}. Max size is 255.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidBoundedNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

BoundedName.prototype.toString = function toString(): string {
  return `BoundedName(name='${this.name}')`;
};

export class InvalidBoundedNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoundedNameError";
  }
}
export class InvalidBoundedNameNameError extends InvalidBoundedNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoundedNameNameError";
  }
}

export class InvalidBoundedNameNameMaxSizeError extends InvalidBoundedNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoundedNameNameMaxSizeError";
  }
}

export class InvalidBoundedNameNameMinSizeError extends InvalidBoundedNameNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoundedNameNameMinSizeError";
  }
}

export class InvalidBoundedNameNameNonEmptyError extends InvalidBoundedNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoundedNameNameNonEmptyError";
  }
}
